import { render, staticRenderFns } from "./Premium.vue?vue&type=template&id=0f332798&scoped=true&"
import script from "./Premium.vue?vue&type=script&lang=ts&"
export * from "./Premium.vue?vue&type=script&lang=ts&"
import style0 from "./Premium.vue?vue&type=style&index=0&id=0f332798&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f332798",
  null
  
)

component.options.__file = "Premium.vue"
export default component.exports